export const templateTypes = {
    DEFAULT: "DEFAULT",
};
